import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import { mensagemDeLogin } from '../services/sessao';
import api from '../services/api';
import { nomeCompleto } from '../data/marca';
import '../styles/Login.css';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [cliente, setCliente] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  // Onda 123: em qual cliente se está entrando, ANTES da senha. A rota é pública e devolve só
  // o nome; se falhar (servidor fora), a tela segue como antes — sem nome, sem erro na cara.
  useEffect(() => {
    let vivo = true;
    api.get('/api/system/identity')
      .then(({ data }) => {
        const nome = String(data?.client_name || '').trim();
        if (!vivo || !nome) return;
        setCliente(nome);
        document.title = nomeCompleto(null, nome);
      })
      .catch(() => {});
    return () => { vivo = false; };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await login(username, password);
      toast.success('Login realizado com sucesso!');
      navigate('/dashboard');
    } catch (error) {
      // Onda 95: servidor inalcançável não pode parecer senha errada.
      toast.error(mensagemDeLogin(error), { duration: 6000 });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          {/* Antes do login a vertical é desconhecida, então aqui aparece só a
              marca, sem descritor. O nome da instalação entra depois, no
              cabeçalho lateral e no título da aba. */}
          <img src={`${process.env.PUBLIC_URL}/marca/logo-horizontal.svg`}
               alt="AcessoiD" className="login-logo" />
          {cliente && <p className="login-cliente">{cliente}</p>}
          <p>Controle de acesso veicular por leitura automática de placas</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Usuário</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Digite seu usuário"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Digite sua senha"
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={loading}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="login-footer">
          <p>Entre com suas credenciais de acesso</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
